import { render, staticRenderFns } from "./UsuarioPerfilCadastro.vue?vue&type=template&id=621f1456&"
import script from "./UsuarioPerfilCadastro.vue?vue&type=script&lang=js&"
export * from "./UsuarioPerfilCadastro.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioPerfilCadastro.vue?vue&type=style&index=0&id=621f1456&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports